var $1caed582a26b1435$exports = {};
$1caed582a26b1435$exports = {
    "endTime": `Sluttid`,
    "startTime": `Starttid`,
    "time": `Tid`
};


export {$1caed582a26b1435$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
